import { render, staticRenderFns } from "./BasicInfoCell.vue?vue&type=template&id=20e02184&scoped=true&"
import script from "./BasicInfoCell.vue?vue&type=script&lang=ts&"
export * from "./BasicInfoCell.vue?vue&type=script&lang=ts&"
import style0 from "./BasicInfoCell.vue?vue&type=style&index=0&id=20e02184&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e02184",
  null
  
)

export default component.exports